/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetTuyaDevicePathParameters } from 'api/actions/get-tuya-device/get-tuya-device-path-parameters';
import { GetTuyaDeviceResponse } from 'api/actions/get-tuya-device/get-tuya-device-response';

type GetTuyaDeviceQueryParameters = Record<string, any>;

/**
 * The path of the GetTuyaDevice action.
 */
export const getTuyaDeviceActionPath = new SweetPath<keyof GetTuyaDevicePathParameters>(
  '/tuya-devices/{tuyaDeviceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetTuyaDevice actions.
 */
export default function createGetTuyaDeviceAction(axios: AxiosInstance) {
  return function getTuyaDeviceAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetTuyaDevicePathParameters;
    query?: GetTuyaDeviceQueryParameters;
  }) {
    const path = getTuyaDeviceActionPath.insert(parameters);

    return axios.get<GetTuyaDeviceResponse, GetTuyaDeviceResponse>(path, { params: query, headers });
  };
}
